export default {
  "pages.layouts.userLayout.title": "軽量倉庫管理",
  "pages.login.pageTitle": "ログイン / 新規登録",
  "pages.login.success": "ログイン成功",
  "pages.login.failure": "ログイン失敗。もう一度お試しください",
  "pages.login.email.placeholder": "メールアドレス",
  "pages.login.email.required": "メールアドレスを入力してください",
  "pages.login.email.invalid": "有効なメールアドレスを入力してください",
  "pages.login.brandPitch":
    "シンプルな入出庫・在庫・棚卸を、個人と小さなチームのために。",
  "pages.login.heroTitle": "AIで、在庫を回す。\n考えて、決める。",
  "pages.login.heroSubtitle":
    "LINE に「りんご 20個 入庫」と送るだけ。AI が補充タイミングを教え、月末には経営レポートを自動生成。",
  "pages.login.slogan.1": "AIで、在庫を回す。",
  "pages.login.slogan.2": "話しかけるだけで、記録が残る。",
  "pages.login.slogan.3": "切れる前に、AI が教える。",
  "pages.login.slogan.4": "月次レポートも、自動で。",
  "pages.login.line": "LINEで続ける",
  "pages.login.google": "Googleで続ける",
  "pages.login.or": "または",
  "pages.login.socialComingSoon": "{provider} ログインは近日公開予定です",
  "pages.login.privacy":
    "続行することで、<terms>利用規約</terms>と<privacy>プライバシーポリシー</privacy>に同意したものとみなされます。",
  "pages.login.openMailbox.gmail": "Gmail を開く ↗",
  "pages.login.openMailbox.yahooJp": "Yahoo!メールを開く ↗",
  "pages.login.openMailbox.yahoo": "Yahoo Mail を開く ↗",
  "pages.login.openMailbox.icloud": "iCloud メールを開く ↗",
  "pages.login.openMailbox.outlook": "Outlook を開く ↗",
  "pages.login.code.send": "メールで続ける",
  "pages.login.code.placeholder": "6桁の認証コード",
  "pages.login.code.required": "認証コードを入力してください",
  "pages.login.code.invalid": "6桁の数字を入力してください",
  "pages.login.code.sent": "認証コードを送信しました",
  "pages.login.code.sentTo": "以下に送信された認証コードを入力してください：{email}",
  "pages.login.code.sendFailed": "認証コードの送信に失敗しました",
  "pages.login.code.resendIn": "{seconds}秒後に再送信できます",
  "pages.login.code.resend": "認証コードを再送信",
  "pages.login.continue": "続ける",
  "pages.login.changeEmail": "← メールアドレスを変更",
  "pages.login.method.email": "メール",
  "pages.login.method.password": "アカウント・パスワード",
  "pages.login.username.placeholder": "ユーザー名またはメールアドレス",
  "pages.login.username.required":
    "ユーザー名またはメールアドレスを入力してください",
  "pages.login.password.placeholder": "パスワード",
  "pages.login.password.required": "パスワードを入力してください",
  "pages.login.password.submit": "ログイン",
  "pages.404.subTitle": "ページが見つかりません",
  "pages.404.buttonText": "ホームに戻る",
  "pages.502.title": "サーバーに接続できません",
  "pages.502.subTitle": "ただいまサーバーが応答していません。しばらくしてから再度お試しください。",
  "pages.502.buttonText": "再読み込み",
  "pages.oauth.title": "ログイン処理中",
  "pages.oauth.processing": "ログイン処理中…",
  "pages.oauth.success": "ログインしました",
  "pages.oauth.fetchUserFailed": "ユーザー情報の取得に失敗しました",
  "pages.oauth.backToLogin": "ログイン画面に戻る",
  "pages.oauth.error.stateMismatch": "認証情報が不正です。もう一度お試しください。",
  "pages.oauth.error.googleFailed": "Google 認証に失敗しました。もう一度お試しください。",
  "pages.oauth.error.disabled": "アカウントが無効化されています。",
  "pages.oauth.error.closing":
    "このアカウントは削除手続き中です。復旧はサポートにお問い合わせください。",
  "pages.oauth.error.generic":
    "ログインに失敗しました。時間を置いてもう一度お試しください。",

  // 共通
  "common.action": "操作",
  "common.edit": "編集",
  "common.delete": "削除",
  "common.cancel": "キャンセル",
  "common.confirm": "確認",
  "common.save": "保存",
  "common.retry": "再試行",
  "common.created": "作成しました",
  "common.updated": "更新しました",
  "common.deleted": "削除しました",
  "common.createdAt": "作成日時",
  "common.reset": "リセット",
  "common.export": "エクスポート",
  "common.exporting": "エクスポート中...",
  "common.export.success": "エクスポート完了",
  "common.export.noData": "エクスポートするデータがありません",
  "common.import": "インポート",
  "common.upload": "クリックしてアップロード",

  // 商品
  "product.title": "商品管理",
  "product.name": "商品名",
  "product.name.placeholder": "商品名を入力",
  "product.name.required": "商品名は必須です",
  "product.sku": "SKU",
  "product.sku.placeholder": "SKUコードを入力（任意）",
  "product.tags": "タグ",
  "product.tags.placeholder": "Enterキーでタグを追加",
  "product.threshold": "在庫不足しきい値",
  "product.threshold.placeholder": "しきい値を入力",
  "product.threshold.invalid": "有効なしきい値を入力してください",
  "product.threshold.tooltip":
    "規格がある商品では、この値はステータス判定には使われず、新規規格を追加する際の既定値としてのみ機能します。各規格はそれぞれのしきい値で判定されます。",
  "product.threshold.parentDefault": "既定 {value}",
  "product.status": "ステータス",
  "product.status.active": "有効",
  "product.status.archived": "アーカイブ済み",
  "product.create": "商品を追加",
  "product.create.manual": "手動入力",
  "product.edit": "商品を編集",
  "product.archive": "アーカイブ",
  "product.unarchive": "復元",
  "product.archived": "アーカイブしました",
  "product.unarchived": "復元しました",
  "product.delete.confirm": "この商品を削除しますか？",
  "product.imageUrl": "商品画像",
  "product.specSize": "規格サイズ",
  "product.specSize.placeholder": "例: 58*36*16",
  "product.remark": "備考",
  "product.remark.placeholder": "備考を入力（任意）",
  "product.contact": "取引先",
  "product.contact.placeholder": "取引先を選択（任意）",
  "product.unit": "単位",
  "product.barcode": "バーコード",
  "product.unitPrice": "単価",
  "product.unitPrice.placeholder": "単価を入力（任意）",
  "product.detail": "商品詳細",
  "product.specDetail": "規格詳細",
  "product.notFound": "商品が見つかりません",
  "product.recentTransactions": "最近の入出庫記録",
  "product.batchThreshold": "一括しきい値設定",
  "product.batchThreshold.desc":
    "選択した{count}件の商品に在庫不足しきい値を設定：",
  "product.image.hint": "最大3枚",
  "product.spec": "規格",
  "product.spec.add": "規格を追加",
  "product.spec.name": "規格名",
  "product.spec.list": "規格一覧",
  "product.spec.images": "規格画像",
  "product.parentProduct": "親商品",
  "product.hasSpecs": "規格あり",
  "product.noSpecs": "規格なし",
  "product.specCount": "件の規格",
  "product.specsColumn": "規格数",
  "product.spec.select": "規格を選択してください",
  "product.delete.hasChildren":
    "この商品には規格が含まれています。先にすべての規格を削除してください",

  // 在庫
  "stock.title": "在庫確認",
  "stock.quantity": "在庫数量",
  "stock.status": "在庫ステータス",
  "stock.status.normal": "正常",
  "stock.status.low": "在庫不足",
  "stock.status.out": "在庫切れ",
  "stock.updatedAt": "最終更新",
  "stock.history.view": "変更履歴",
  "stock.history.title": "在庫変更履歴",
  "stock.history.type": "種別",
  "stock.history.quantity": "数量",
  "stock.history.type.inventoryCheck": "棚卸調整",
  "stock.history.type.manual": "手動調整",
  "stock.history.total": "合計 {total} 件",
  "stock.count": "棚卸",
  "stock.count.start": "棚卸を開始",
  "stock.count.started": "棚卸を開始しました",
  "stock.count.banner":
    "棚卸中 · {date} · {count} 件カウント済み · 差異 {variance} 件",
  "stock.count.status": "棚卸状況",
  "stock.count.uncounted": "未カウント",
  "stock.count.counted": "実数 {qty}",
  "stock.count.title": "棚卸入力",
  "stock.count.saved": "保存しました",
  "stock.count.noNext": "未カウントの商品はこれ以上ありません",
  "stock.count.noSpecs": "この商品には棚卸できる規格がありません",
  "stock.count.loadFailed": "棚卸データの読み込みに失敗しました",
  "stock.count.loadFailed.desc":
    "現在の棚卸状況が正しく表示されていない可能性があります。入力済みの実数量を上書きしないよう、棚卸機能を一時的に停止しました。再試行してください。",

  // 取引記録（入出庫）
  "transaction.title": "入出庫",
  "transaction.operation": "入出庫操作",
  "transaction.tab.register": "入出庫登録",
  "transaction.tab.history": "入出庫履歴",
  "transaction.batch.title": "入出庫登録",
  "transaction.batch.items": "商品明細",
  "transaction.batch.addProduct": "商品を追加",
  "transaction.batch.empty": "商品を1点以上追加し、数量を入力してください",
  "transaction.batch.empty.hint": "商品が未追加です。「商品を追加」から開始してください",
  "transaction.batch.duplicate": "この商品は既に明細にあります",
  "transaction.batch.itemCount": "品目数",
  "transaction.batch.totalQty": "数量合計",
  "transaction.contact.placeholder": "取引先を選択（任意）",
  "transaction.history.bySlip": "伝票単位",
  "transaction.history.byDetail": "明細単位",
  "transaction.slip.void.confirm": "この伝票（全明細）を一括で取消しますか？",
  "transaction.productInfo": "商品情報",
  "transaction.type": "入出庫タイプ",
  "transaction.type.in": "入庫",
  "transaction.type.out": "出庫",
  "transaction.quantity": "数量",
  "transaction.quantity.required": "数量を入力してください",
  "transaction.contact": "取引先",
  "transaction.remark": "備考",
  "transaction.remark.placeholder": "備考を入力（任意）",
  "transaction.status": "ステータス",
  "transaction.normal": "有効",
  "transaction.voided": "無効化済み",
  "transaction.void": "無効化",
  "transaction.void.confirm":
    "この取引記録を無効化しますか？逆仕訳により在庫が復元されます。",
  "transaction.void.success": "無効化しました",
  "transaction.in": "入庫",
  "transaction.out": "出庫",
  "transaction.in.submit": "入庫を確定",
  "transaction.out.submit": "出庫を確定",
  "transaction.in.success": "入庫完了",
  "transaction.out.success": "出庫完了",
  "transaction.product.required": "商品を選択してください",
  "transaction.specList": "規格一覧",
  "transaction.specName": "規格名",
  "transaction.productSpecName": "商品名 / 規格名",
  "transaction.specTag": "規格",
  "transaction.specInfo": "規格情報",
  "transaction.currentStock": "現在庫",
  "transaction.transactionQty": "入出庫数量",
  "transaction.referenceNo": "伝票番号",
  "transaction.referenceNo.placeholder": "伝票番号を入力",
  "transaction.transactionDate": "入出庫日",
  "transaction.remainingStock": "残在庫",
  "transaction.unitPrice": "単価",
  "transaction.operator": "担当者",
  "transaction.history": "入出庫履歴",
  "transaction.selectProduct": "商品を選択",
  "transaction.select": "選択",
  "transaction.addProduct": "商品を追加",
  "transaction.searchProduct": "商品名",
  "transaction.submit": "登録",
  "transaction.clearCancel": "クリア/取消",
  "transaction.selectProductHint": "商品を選択してください",
  "transaction.notSet": "未設定",
  "transaction.search.productName": "商品名",
  "transaction.search.dateRange": "操作日時",
  "transaction.search.stockRange": "在庫",
  "transaction.search.min": "最小値",
  "transaction.search.max": "最大値",

  // ダッシュボード
  "dashboard.title": "ダッシュボード",
  "dashboard.totalProducts": "商品総数",
  "dashboard.totalStock": "在庫総数",
  "dashboard.todayIn": "本日入庫",
  "dashboard.todayOut": "本日出庫",
  "dashboard.lowStockAlert": "在庫不足アラート",
  "dashboard.recentTransactions": "最近の記録",
  "dashboard.unit": "種類",
  "dashboard.items": "個",
  "dashboard.vsYesterday": "前日比",
  "dashboard.lowStockCount": "在庫不足",
  "dashboard.outOfStockCount": "在庫切れ",
  "dashboard.txTrend": "入出庫トレンド",
  "dashboard.stockDistribution": "在庫ステータス分布",
  "dashboard.topProducts": "入出庫数ランキング",
  "dashboard.7days": "7日間",
  "dashboard.14days": "14日間",
  "dashboard.30days": "30日間",
  "dashboard.viewAll": "すべて見る",
  "dashboard.noLowStock": "在庫不足の商品はありません",
  "dashboard.outOfStockAlert": "要対応",
  "dashboard.noOutOfStock": "在庫切れの商品はありません",
  "dashboard.subtitle": "在庫の状況と要対応を一目で確認",
  "dashboard.kpi.title": "在庫サマリー",
  "dashboard.kpi.products": "商品数",
  "dashboard.kpi.outOfStock": "在庫切れ",
  "dashboard.kpi.lowStock": "在庫少",
  "dashboard.kpi.monthOutbound": "今月の出庫件数",
  "dashboard.actions.title": "要対応",
  "dashboard.actions.count": "{count} 件",
  "dashboard.actions.viewAll": "すべて見る",
  "dashboard.actions.empty": "対応が必要な項目はありません",
  "dashboard.actions.tag.check": "棚卸",
  "dashboard.actions.checkOverdue.empty": "棚卸の記録がありません",
  "dashboard.actions.checkOverdue.days": "{days} 日以上棚卸が未実施",
  "dashboard.actions.tag.out": "切れ",
  "dashboard.actions.tag.low": "少",
  "dashboard.actions.detail.remaining": "残 {qty}",
  "dashboard.actions.detail.remainingThreshold": "残 {qty} / 閾値 {threshold}",
  "dashboard.ai.bind.title": "LINE と連携して AI 提案を受け取る",
  "dashboard.ai.bind.desc": "「りんご 20個 入庫」のように LINE に送るだけ。AI が毎朝 補充提案をプッシュします。",
  "dashboard.ai.bind.cta": "連携する",
  "dashboard.ai.recommend.title": "今日の AI レコメンド",
  "dashboard.ai.recommend.count": "{count} 件",
  "dashboard.ai.recommend.viewAll": "すべて見る",
  "dashboard.ai.urgency.high": "緊急",
  "dashboard.ai.urgency.medium": "注意",
  "dashboard.ai.urgency.low": "予防",
  "dashboard.ai.product.unknown": "（商品未特定）",
  "dashboard.ai.recommend.qtyHint": "個推奨 / 在庫 {stock}",

  // 取引先
  "contact.title": "取引先",
  "contact.name": "名称",
  "contact.name.required": "取引先名を入力してください",
  "contact.type": "種類",
  "contact.type.placeholder": "Enterキーで種類タグを追加",
  "contact.type.tooltip": "自由に入力できます。仕入先・販売先・運送業者など、取引先を分類するためのタグです。",
  "contact.remark": "備考",
  "contact.create": "取引先を追加",
  "contact.edit": "取引先を編集",
  "contact.delete.confirm": "この取引先を削除しますか？",


  // 棚卸
  "inventoryCheck.title": "棚卸管理",
  "inventoryCheck.date": "棚卸日",
  "inventoryCheck.status": "ステータス",
  "inventoryCheck.status.open": "実施中",
  "inventoryCheck.status.completed": "完了",
  "inventoryCheck.status.voided": "取消済み",
  "inventoryCheck.completedAt": "完了日時",
  "inventoryCheck.view": "詳細",
  "inventoryCheck.detail": "棚卸詳細",
  "inventoryCheck.items": "棚卸項目",
  "inventoryCheck.bookQty": "帳簿数量",
  "inventoryCheck.actualQty": "実数量",
  "inventoryCheck.difference": "差異",
  "inventoryCheck.complete": "棚卸を確定",
  "inventoryCheck.complete.confirm":
    "棚卸を確定しますか？在庫調整記録が生成されます。",
  "inventoryCheck.complete.noItems": "先に在庫画面で棚卸してください",
  "inventoryCheck.completed": "棚卸が完了しました",
  "inventoryCheck.void": "取消",
  "inventoryCheck.void.confirm": "この棚卸を取り消しますか？",
  "inventoryCheck.voided": "棚卸を取り消しました",
  "inventoryCheck.notFound": "棚卸データが見つかりません",
  "inventoryCheck.inputActualQty": "実数量を入力",
  "inventoryCheck.actualQty.empty": "未入力",
  "inventoryCheck.actualQty.required": "実数量を入力してください（空欄は不可）",
  "inventoryCheck.continueActive": "進行中の棚卸を続ける",
  "inventoryCheck.active.viewSheet": "棚卸票を表示",
  "inventoryCheck.active.completeNow": "棚卸を完了",
  "inventoryCheck.matchBook": "帳簿数と一致",
  "inventoryCheck.saveAndNext": "保存して次へ",
  "inventoryCheck.removeItem": "この項目を取消",
  "inventoryCheck.removed": "この商品の棚卸を取り消しました",
  "inventoryCheck.progress": "カウント済み商品",
  "inventoryCheck.varianceCount": "差異件数",
  "inventoryCheck.varianceTotal": "差異合計",
  "inventoryCheck.variance.match": "一致",
  "inventoryCheck.drift.title": "一部商品の帳簿数量が変動しました",
  "inventoryCheck.drift.desc":
    "以下の商品は棚卸期間中に入出庫が発生しました。在庫は棚卸差異で調整済みです。ご確認ください：",
  "inventoryCheck.currentQty": "現在庫",
  "inventoryCheck.item.search": "商品 / SKU を検索",
  "inventoryCheck.items.loadFailed": "棚卸明細の読み込みに失敗しました",
  "inventoryCheck.items.loadFailed.desc":
    "一覧が不完全な可能性があります。データのある棚卸伝票を誤って取消さないよう、取消操作を一時的に無効にしています。再試行してください。",
  "inventoryCheck.item.delete": "削除",
  "inventoryCheck.item.deleted": "棚卸項目を削除しました",
  "inventoryCheck.item.delete.confirm": "この棚卸項目を削除しますか？",
  "inventoryCheck.goStockCount": "在庫画面で棚卸",
  "inventoryCheck.export": "エクスポート",
  "inventoryCheck.export.filename": "棚卸表",
  "inventoryCheck.export.failed": "エクスポートに失敗しました。時間をおいて再試行してください",
  "inventoryCheck.itemCount": "カウント件数",
  "inventoryCheck.list.hint": "棚卸は在庫画面から。ここは履歴台帳です",
  "inventoryCheck.complete.result": "棚卸が完了しました（{count} 商品を調整）",

  // 設定
  "settings.tab.account": "アカウント設定",
  "settings.tab.security": "セキュリティ設定",
  "settings.tab.business": "業務設定",
  "settings.tab.subscription": "サブスクリプション",
  "settings.account.info": "アカウント情報",
  "settings.account.username": "ユーザー名",
  "settings.account.tenant": "テナントID",
  "settings.account.userCode": "ユーザー番号",
  "settings.account.createdAt": "登録日時",
  "lang.ja-JP": "日本語",
  "lang.en-US": "英語",
  "lang.zh-CN": "中国語（簡体字）",
  "lang.zh-TW": "中国語（繁体字）",
  "settings.account.displayName": "表示名",
  "settings.account.displayNamePlaceholder": "表示名を入力",
  "settings.account.displayNameHint":
    "設定すると、アカウント名の代わりに表示されます",
  "settings.account.displayNameEdit": "変更",
  "settings.account.displayNameSuccess": "表示名を更新しました",
  "settings.password.title": "パスワード変更",
  "settings.password.changeDesc":
    "メール認証コードで、新しいパスワードに変更できます。現在のパスワードの入力は不要です。",
  "settings.password.old": "現在のパスワード",
  "settings.password.new": "新しいパスワード",
  "settings.password.confirm": "新しいパスワード（確認）",
  "settings.password.minLength": "パスワードは6文字以上で入力してください",
  "settings.password.mismatch": "パスワードが一致しません",
  "settings.password.submit": "パスワードを変更",
  "settings.password.success": "パスワードを変更しました",
  "settings.password.code": "認証コード",
  "settings.password.codePlaceholder": "6桁の認証コード",
  "settings.password.sendCode": "認証コードを送信",
  "settings.password.codeResendIn": "{seconds}秒後に再送信",
  "settings.password.codeSent": "認証コードを送信しました",
  "settings.password.codeSentTo": "認証コードを {email} に送信します",
  "settings.password.codeInvalid": "6桁の数字を入力してください",
  "settings.business.title": "業務設定",
  "settings.business.defaultThreshold": "デフォルト在庫不足しきい値",
  "settings.business.defaultThreshold.tip":
    "新規商品作成時のデフォルト在庫不足しきい値",
  "settings.business.save": "設定を保存",
  "settings.fieldVisibility.title": "フィールド表示",
  "settings.fieldVisibility.desc":
    "フィールドを個別にオン／オフできます。オフにしたフィールドは入力欄に表示されませんが、既存データは保持されます。",
  "settings.fieldVisibility.updated": "更新しました",
  "settings.fieldVisibility.entity.product": "商品",
  "settings.fieldVisibility.field.product.sku": "SKU",
  "settings.fieldVisibility.field.product.specSize": "規格サイズ",
  "settings.fieldVisibility.field.product.contact": "取引先",
  "settings.fieldVisibility.field.product.unit": "単位",
  "settings.fieldVisibility.field.product.barcode": "バーコード",
  "settings.fieldVisibility.field.product.unitPrice": "単価",
  "settings.fieldVisibility.entity.transaction": "入出庫記録",
  "settings.fieldVisibility.field.transaction.unitPrice": "入出庫単価",
  "settings.tab.app": "アプリ設定",
  "settings.app.title": "アプリカスタマイズ",
  "settings.app.icon": "アプリアイコン",
  "settings.app.icon.desc":
    "モバイルアプリ用のカスタムアイコンをアップロードします。推奨：1024×1024 px の PNG 画像。",
  "settings.app.icon.upload": "アイコンをアップロード",
  "settings.app.icon.change": "アイコンを変更",
  "settings.app.icon.delete": "アイコンを削除",
  "settings.app.icon.deleteConfirm": "現在のアイコンを削除しますか？",
  "settings.app.icon.requirement": "PNG形式、正方形、512×512 px以上推奨",
  "settings.app.icon.success": "アイコンを更新しました",
  "settings.app.icon.deleteSuccess": "アイコンを削除しました",
  "settings.app.icon.sizeError":
    "画像は正方形で、512×512ピクセル以上である必要があります",
  "settings.subscription.title": "現在のサブスクリプション",
  "settings.subscription.plan": "プラン",
  "settings.subscription.maxProducts": "商品上限",
  "settings.subscription.maxTransactions": "月間取引上限",
  "settings.subscription.perMonth": " 件/月",

  // フィードバック
  "feedback.title": "フィードバック",
  "feedback.submit": "送信",
  "feedback.submit.success":
    "フィードバックありがとうございます。確認の上対応いたします",
  "feedback.category": "カテゴリ",
  "feedback.category.bug": "バグ",
  "feedback.category.suggestion": "提案",
  "feedback.category.feature": "機能リクエスト",
  "feedback.category.dissatisfied": "不満",
  "feedback.content": "内容",
  "feedback.content.placeholder": "問題や提案を記述してください...",
  "feedback.content.required": "内容を入力してください",
  "feedback.screenshot": "スクリーンショット（任意）",
  "feedback.screenshot.add": "スクリーンショット",
  "feedback.screenshot.typeError": "画像ファイルのみアップロード可能です",
  "feedback.screenshot.sizeError": "画像サイズは2MB以内にしてください",
  "feedback.contactEmail": "連絡先メール（任意）",
  "feedback.contactEmail.placeholder": "ご返信先",
  "feedback.contactEmail.invalid": "有効なメールアドレスを入力してください",

  // NPS アンケート
  "nps.title": "この製品を友人に薦めたいと思いますか？",
  "nps.subtitle": "0 = 全くそう思わない、10 = 強くそう思う",
  "nps.unlikely": "そう思わない",
  "nps.likely": "そう思う",
  "nps.comment.placeholder": "ご意見をお聞かせください（任意）",
  "nps.thanks": "ご評価ありがとうございます",

  // サブスクリプション & アップグレード
  "subscription.unlimited": "無制限",
  "subscription.upgrade.title": "Proにアップグレード",
  "subscription.upgrade.desc":
    "すべての機能を解放し、業務効率を向上させましょう",
  "subscription.upgrade.button": "今すぐアップグレード",
  "subscription.upgrade.success": "アップグレード完了",
  "subscription.upgrade.feature.export": "Excel / CSVエクスポート対応",
  "subscription.upgrade.feature.unlimited": "商品・取引記録を無制限に利用",
  "subscription.upgrade.feature.stats": "基本統計とデータ分析",

  // 料金プラン
  "pricing.title": "最適なプランをお選びください",
  "pricing.subtitle": "無料プランから始めて、いつでもアップグレードできます",
  "pricing.monthly": "月払い",
  "pricing.annual": "年払い",
  "pricing.save": "{percent}%お得",
  "pricing.free": "無料",
  "pricing.freeDesc": "基本的な倉庫管理を無料で体験",
  "pricing.proDesc": "すべての機能を無制限にご利用いただけます",
  "pricing.upgradeNow": "今すぐアップグレード",
  "pricing.currentPlan": "現在のプラン",
  "pricing.currentPlanBtn": "現在のプラン",
  "pricing.downgrade": "ダウングレード",
  "pricing.recommended": "おすすめ",
  "pricing.perMonth": "月",
  "pricing.billedAnnually": "年一括払い {amount}",
  "pricing.note":
    "すべてのプランに14日間の無料トライアルが含まれます。クレジットカード不要",
  "pricing.noPriceConfig":
    "料金情報を取得できませんでした。しばらくしてから再度お試しください",
  "pricing.checkoutFailed":
    "決済ページに移動できませんでした。しばらくしてから再度お試しください",
  "pricing.unlimited": "無制限",
  "pricing.feature.products": "商品管理",
  "pricing.feature.transactions": "取引記録",
  "pricing.feature.stockManagement": "在庫管理",
  "pricing.feature.inventoryCheck": "棚卸機能",
  "pricing.feature.export": "Excel / CSVエクスポート",
  "pricing.feature.statistics": "統計とデータ分析",
  "pricing.feature.scan": "バーコードスキャン",

  // 設定 - サブスクリプション管理
  "settings.subscription.status": "ステータス",
  "settings.subscription.nextBilling": "次回請求日",
  "settings.subscription.viewPlans": "プランを見る",
  "settings.subscription.changePlan": "プランを変更",
  "settings.subscription.manageBilling": "請求管理",
  "settings.subscription.cancel": "サブスクリプションを解約",
  "settings.subscription.cancelConfirmTitle":
    "サブスクリプションを解約しますか？",
  "settings.subscription.cancelConfirmDesc":
    "現在の請求期間終了まではPro機能をご利用いただけます。その後、無料プランにダウングレードされます。",
  "settings.subscription.confirmCancel": "解約を確定",
  "settings.subscription.cancelSuccess":
    "サブスクリプションを解約しました。現在の請求期間終了後に無料プランに変更されます",
  "settings.subscription.portalFailed":
    "請求管理ページを開けませんでした。しばらくしてから再度お試しください",
  "settings.subscription.gracePeriodWarning": "決済失敗",
  "settings.subscription.gracePeriodDesc":
    "サブスクリプションの決済に失敗しました。{date}までにお支払い方法を更新してください。更新がない場合、無料プランにダウングレードされます。",
  "settings.subscription.trialRemaining": "トライアル残り{days}日",

  // ─── スマート分析 ──────────────────────────────────────────────────
  "analytics.title": "スマート分析",
  "analytics.shipmentTrend": "出庫トレンド",
  "analytics.replenishment": "補充提案",
  "analytics.productAnalysis": "商品分析",
  "analytics.movingAverage": "移動平均",
  "analytics.periodicity": "周期性検出",
  "analytics.granularity.day": "日次",
  "analytics.granularity.week": "週次",
  "analytics.granularity.month": "月次",
  "analytics.timeRange": "期間",
  "analytics.tags": "タグで絞り込み",
  "analytics.includeInbound": "入庫を表示",
  "analytics.outbound": "出庫",
  "analytics.inbound": "入庫",
  "analytics.last30days": "直近30日",
  "analytics.last90days": "直近90日",
  "analytics.custom": "カスタム",
  "analytics.items": "件",
  "analytics.days": "日",
  "analytics.dailyOut": "日次出庫量",
  "analytics.ma7": "7日移動平均",
  "analytics.ma14": "14日移動平均",
  "analytics.dow.1": "月曜",
  "analytics.dow.2": "火曜",
  "analytics.dow.3": "水曜",
  "analytics.dow.4": "木曜",
  "analytics.dow.5": "金曜",
  "analytics.dow.6": "土曜",
  "analytics.dow.7": "日曜",
  "analytics.peakDay": "ピーク日",
  "analytics.avgOut": "平均出庫量",
  "analytics.urgency": "緊急度",
  "analytics.urgency.all": "すべて",
  "analytics.urgency.immediate": "即時補充",
  "analytics.urgency.today": "本日",
  "analytics.urgency.thisWeek": "今週中",
  "analytics.urgency.twoWeeks": "2週間以内",
  "analytics.urgency.noAction": "補充不要",
  "analytics.currentStock": "現在の在庫",
  "analytics.dailyAvgOut": "日次平均出庫",
  "analytics.estimatedDaysLeft": "予想消費日数",
  "analytics.suggestedQuantity": "推奨補充量",
  "analytics.insufficientData": "データ蓄積中",
  "analytics.insufficientDataDesc":
    "分析を生成するにはより多くの出庫記録が必要です。引き続きシステムをご利用ください。",
  "analytics.insufficientDataCount": "{count}件の商品データが不足",
  "analytics.selectProduct": "商品を選択して詳細分析を表示",
  "analytics.viewAnalysis": "分析を表示",
  "analytics.formulaNote": "計算方法",
  "analytics.perDay": "件/日",
  "analytics.aboutDays": "約{days}日",

  // --- ログアウト ---
  "settings.account.logout": "ログアウト",
  "settings.account.logoutDesc": "現在のアカウントからログアウトします。次回は再度ログインが必要です。",
  "settings.account.logoutConfirmTitle": "ログアウトしますか？",

  // --- アカウント削除 ---
  "settings.account.dangerZone": "危険な操作",
  "settings.account.deleteAccount": "アカウントを削除",
  "settings.account.deleteAccountDesc":
    "削除後、アカウントは30日後に完全に削除されます。この期間中はいつでもログインしてアカウントを復元できます。",
  "settings.account.deleteConfirmTitle": "アカウント削除の確認",
  "settings.account.deleteConfirmDesc":
    "パスワードを入力して確認してください。削除後はログアウトされます。30日以内にログインしてアカウントを復元できます。",
  "settings.account.deleteConfirmPassword": "パスワードを入力",
  "settings.account.deleteConfirmEmailDesc":
    "削除を確認するため、アカウントのメールアドレス {email} を入力してください。削除後はログアウトされ、30日以内にログインして復元できます。",
  "settings.account.deleteConfirmEmailRequired": "メールアドレスを入力してください",
  "settings.account.deleteConfirmEmailMismatch":
    "メールアドレスがアカウントと一致しません",
  "settings.account.deleteDataNotice":
    "30日経過後、以下のデータは完全に削除され、復元できません",
  "settings.account.deleteDataItem.records": "入出庫記録",
  "settings.account.deleteDataItem.stock": "在庫記録",
  "settings.account.deleteDataItem.products": "商品情報",
  "settings.account.deleteDataItem.user": "アカウント情報",
  "settings.account.deleteSuccess": "アカウント削除リクエストが送信されました",

  // --- アカウント復元 ---
  "accountClosing.title": "アカウント削除処理中",
  "accountClosing.desc":
    "アカウントの削除がリクエストされています。復元可能な残り日数は{days}日です。期限を過ぎるとすべてのデータが完全に削除されます。",
  "accountClosing.restore": "アカウントを復元",
  "accountClosing.restoreConfirmTitle": "アカウントを復元しますか？",
  "accountClosing.restoreConfirmPassword":
    "復元を確認するためにパスワードを入力してください",
  "accountClosing.restoreConfirmEmail":
    "復元を確認するためにアカウントのメールアドレス {email} を入力してください",
  "accountClosing.restoreSuccess":
    "アカウントが復元されました。おかえりなさい！",
  "accountClosing.logout": "ログアウト",

  // お知らせ
  "notice.tab.system": "お知らせ",
  "notice.tab.todo": "やること",
  "notice.empty": "お知らせはありません",
  "notice.todo.empty": "やることはありません",
  "notice.readAll": "すべて既読にする",
  "notice.markSelectedRead": "既読にする",
  "notice.selected": "{count} 件選択中",
  "notice.viewAll": "すべて表示",

  "notice.col.content": "メッセージ内容",
  "notice.col.time": "受信日時",
  "notice.col.type": "メッセージタイプ",
  "notice.type.notice": "お知らせ",
  "notice.type.announcement": "アナウンス",
  "notice.detail.title": "メッセージ詳細",
  "notice.pagination.total": "合計 {total} 件",

  // チーム招待
  "invitation.inbox.title": "招待リスト",
  "invitation.inbox.line": "{inviter} さんが「{team}」チームへの参加を招待しています",
  "invitation.inbox.expiresAt": "有効期限：{date}",
  "invitation.accept": "参加する",
  "invitation.decline": "辞退する",
  "invitation.declineConfirm": "この招待を辞退しますか？",
  "invitation.acceptSuccess": "「{team}」に参加しました。右上のチーム切替から確認できます",

  // 設定 - お知らせ
  "settings.tab.notices": "お知らせ",
  "settings.notices.title": "お知らせ",

  // 設定 - チーム管理
  "settings.tab.team": "チーム管理",
  "team.title": "チームメンバー",
  "team.invite": "メンバーを招待",
  "team.invite.title": "新しいメンバーを招待",
  "team.invite.email": "メールアドレス",
  "team.invite.emailInvalid": "正しいメールアドレスを入力してください",
  "team.invite.displayName": "表示名（任意）",
  "team.invite.displayName.tip": "招待を受け入れた後、この名前で表示されます",
  "team.invite.message": "メッセージ（任意）",
  "team.invite.checking": "メールアドレスを確認中…",
  "team.invite.alreadyMember": "このメールアドレスはすでにチームメンバーです",
  "team.invite.alreadyPending": "このメールアドレスには未処理の招待があります。再送できます。",
  "team.invite.accountExists": "このメールは Stockware に登録済みです。承諾されるとメンバーとして参加します。",
  "team.invite.accountNew": "このメールでアカウントを作成してチームに参加します",
  "team.invite.success": "招待を送信しました",
  "team.invite.resend": "再送",
  "team.invite.resendSuccess": "招待を再送しました",
  "team.invite.revoke": "取り消し",
  "team.invite.revokeConfirm": "この招待を取り消しますか？",
  "team.invite.col.email": "メールアドレス",
  "team.invite.col.expiresAt": "有効期限",
  "team.invite.col.createdAt": "招待日時",
  "team.invitations.title": "未処理の招待",
  "teamSwitcher.title": "チームを切替",
  "teamSwitcher.switched": "「{team}」に切り替えました",
  "team.col.displayName": "表示名",
  "team.col.username": "ユーザー名",
  "team.col.role": "ロール",
  "team.col.status": "ステータス",
  "team.role.owner": "オーナー",
  "team.role.member": "メンバー",
  "team.status.active": "有効",
  "team.status.disabled": "無効",
  "team.status.invited": "招待中",
  "team.edit": "編集",
  "team.edit.success": "メンバー情報を更新しました",
  "team.remove": "削除",
  "team.remove.confirm": "このメンバーを削除しますか？削除後はログインできなくなります。",
  "team.disable": "無効化",
  "team.enable": "有効化",

  // チーム - 権限設定
  "team.permissions": "権限設定",
  "team.permissions.title": "権限を編集 - {name}",
  "team.permissions.selectAll": "すべて選択",
  "team.permissions.resetDefaults": "デフォルトに戻す",
  "team.permissions.resetDefaults.confirm": "デフォルトの権限に戻しますか？",
  "team.permissions.save.success": "権限設定を保存しました",
  "team.permissions.reset.success": "デフォルトの権限に戻しました",
  "team.permissions.custom": "カスタム",
  "team.permissions.default": "デフォルト",
  "team.permissions.col.category": "分類",
  "team.permissions.col.target": "操作対象",
  "team.permissions.col.permissions": "機能権限",
  "team.permissions.module.warehouse": "倉庫管理",
  "team.permissions.module.smart_analytics": "スマート分析",
  "team.permissions.group.product": "商品管理",
  "team.permissions.group.stock": "在庫",
  "team.permissions.group.transaction": "入出庫",
  "team.permissions.group.inventory-check": "棚卸",
  "team.permissions.group.contact": "取引先",
  "team.permissions.group.expense": "支出",
  "team.permissions.group.income": "収入",
  "team.permissions.group.analytics": "データ分析",
  "team.permissions.action.list": "閲覧",
  "team.permissions.action.add": "追加",
  "team.permissions.action.edit": "編集",
  "team.permissions.action.delete": "削除",
  "team.permissions.action.void": "取消",
  "team.permissions.action.export": "エクスポート",
  "team.permissions.action.view": "閲覧",
  "team.permissions.action.category": "カテゴリ管理",

  // 14日間トライアル招待モーダル
  "trialOffer.title": "Pro を 14 日間無料で試す",
  "trialOffer.subtitle": "クレジットカード不要、全機能を体験",
  "trialOffer.body": "現在は無料版です。試用期間中はすべての機能をご利用いただけ、14 日後は自動的に無料版に戻ります。お一人様一回限り。",
  "trialOffer.accept": "今すぐ試用を始める",
  "trialOffer.decline": "今はやめておく",
  "trialOffer.successMessage": "試用を開始しました。ご利用をお楽しみください",
  "trialOffer.failedMessage": "試用の開始に失敗しました。後ほど再度お試しください",

  // 初期パスワードの変更
  "changeInitialPassword.title": "初期パスワードの変更",
  "changeInitialPassword.hint":
    "アカウント保護のため、初期パスワードの変更をおすすめします",
  "changeInitialPassword.new": "新しいパスワード",
  "changeInitialPassword.confirm": "新しいパスワード（確認）",
  "changeInitialPassword.submit": "変更を確定",
  "changeInitialPassword.skip": "スキップして後で変更",
  "changeInitialPassword.success": "パスワードを変更しました",

  // 公開サポートページ（/support）。App Store Connect の「サポートURL」として提出する。
  "pages.support.pageTitle": "サポートセンター",
  "pages.support.lead":
    "Stockware（在庫管理アプリ）をご利用中のお客様向けのサポートページです。まず「よくある質問」をご確認ください。解決しない場合は、お気軽にお問い合わせください。",
  "pages.support.contact.heading": "お問い合わせ",
  "pages.support.contact.intro":
    "ご利用中に問題が発生した場合や、機能に関するご要望は、以下のメールアドレスまでご連絡ください。ご利用の端末（iPhone / Android / ブラウザ）とアプリのバージョン、発生した状況をあわせてお知らせいただくと、より早くご案内できます。",
  "pages.support.contact.operatorLabel": "運営会社",
  "pages.support.contact.emailLabel": "メール",
  "pages.support.contact.hoursLabel": "受付時間",
  "pages.support.contact.hoursValue": "平日 10:00〜18:00（土日祝を除く）",
  "pages.support.contact.replyLabel": "返信の目安",
  "pages.support.contact.replyValue": "2〜3営業日以内",
  "pages.support.faq.heading": "よくある質問",
  "pages.support.faq.q1": "ログインできません。認証コードのメールが届きません。",
  "pages.support.faq.a1":
    "Stockware はメールアドレスに送信する6桁の認証コード、またはパスワード、Google アカウントでログインできます。認証コードが届かない場合は、迷惑メールフォルダをご確認いただき、60秒後に「認証コードを再送信」をお試しください。それでも届かない場合は、お問い合わせ先までご連絡ください。",
  "pages.support.faq.q2": "パスワードを忘れました。",
  "pages.support.faq.a2":
    "ログイン画面で「メール認証コードでログイン」を選ぶと、パスワードなしでログインできます。ログイン後、アプリの「マイページ → 設定 → パスワードを変更」から、メール認証コードで新しいパスワードを設定できます。現在のパスワードの入力は不要です。",
  "pages.support.faq.q3": "在庫数が実際の数と合いません。",
  "pages.support.faq.a3":
    "棚卸機能で調整できます。在庫画面から「棚卸を開始」し、実際に数えた数量を入力してください。帳簿数との差異は自動で計算され、確定すると在庫調整の記録が作成されます。棚卸中に入出庫があった商品は、確定時にお知らせします。",
  "pages.support.faq.q4": "間違えて登録した商品を消したいです。",
  "pages.support.faq.a4":
    "商品一覧または商品詳細から「アーカイブ」すると、通常の一覧に表示されなくなります（入出庫の記録は残ります）。完全に消す場合は「削除」をご利用ください。削除は取り消せませんので、実績のある商品はアーカイブをおすすめします。",
  "pages.support.faq.q5": "スタッフや家族と一緒に使えますか。",
  "pages.support.faq.a5":
    "「マイページ → チーム管理」からメールアドレスでメンバーを招待できます。役割（オーナー / メンバー）と権限はメンバーごとに設定でき、停止や削除も可能です。複数のチームに所属している場合は、アプリ内でチームを切り替えられます。",
  "pages.support.faq.q6": "アカウントを削除したいです。",
  "pages.support.faq.a6":
    "アプリの「マイページ → 設定 → アカウントを削除」から申請できます。削除申請後30日間は、ログインすることでアカウントを復元できます。30日を過ぎると、入出庫記録・在庫記録・商品記録・ユーザー情報はすべて完全に削除され、復元できません。",
  "pages.support.links.heading": "関連リンク",
  "pages.support.links.site": "公式サイト",
  "pages.support.links.terms": "利用規約",
  "pages.support.links.privacy": "プライバシーポリシー",
};
